import { useIsReadonly } from "@/components/PowerBlock/Block/readonly-context";
import { Toggle } from "@/components/Toggle";
import { Skeleton } from "@/components/ui/skeleton";

interface VerboseModeToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  showVerboseMode?: boolean;
  isLoading?: boolean;
}

const VerboseModeToggle = ({
  enabled,
  onChange,
  showVerboseMode = true,
  isLoading = false,
}: VerboseModeToggleProps) => {
  const isReadonly = useIsReadonly();
  if (!showVerboseMode) {
    return null;
  }

  return (
    <div className="flex items-center justify-between">
      <div className="flex-1">
        <span className="text-sm text-gray-700">Verbose Mode</span>
        <p className="mt-1 text-xs text-gray-500">
          When enabled, the agent will return more detailed information about the execution.
        </p>
      </div>
      {isLoading ? (
        <Skeleton width={44} height={24} borderRadius={12} />
      ) : (
        <Toggle enabled={enabled} setEnabled={onChange} disabled={isReadonly} />
      )}
    </div>
  );
};

export default VerboseModeToggle;
